import script from "./UserAdd.vue?vue&type=script&setup=true&lang=js"
export * from "./UserAdd.vue?vue&type=script&setup=true&lang=js"

import "./UserAdd.vue?vue&type=style&index=0&id=fe00aa9c&scoped=true&lang=less"

import exportComponent from "../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['__scopeId',"data-v-fe00aa9c"]])

export default __exports__